import { Filter } from '@elderbyte/ngx-starter'

export class WorkBatchPackagesFilterBuilder {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public static readonly WORK_BATCH_ID = 'workBatchId'

  private _workBatchId: string

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static workBatchId(workBatchId: string): Filter {
    return this.start().workBatchId(workBatchId).build()[0]
  }

  public static start(): WorkBatchPackagesFilterBuilder {
    return new WorkBatchPackagesFilterBuilder()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public workBatchId(workBatchId: string): WorkBatchPackagesFilterBuilder {
    this._workBatchId = workBatchId
    return this
  }

  public build(): Filter[] {
    const filters: Filter[] = []
    if (this._workBatchId) {
      filters.push(new Filter(WorkBatchPackagesFilterBuilder.WORK_BATCH_ID, this._workBatchId))
    }

    return filters
  }
}
